import ErrorType from '../../../../types/report/ErrorType';
import UserDefinedFunction from '../../../../types/report/UserDefinedFunction';
import UserDefinedFunctionParameter from '../../../../types/report/UserDefinedFunctionParameter';
import clear from '../../common/array/clear';
import stringHelper from '../../common/stringHelper';
import declarationValidator from './declarationValidator';
import uniquenessValidator from './uniquenessValidator';

const maxNameCharacters = 50;

const validateFunctionParameter = (parameter: UserDefinedFunctionParameter): void => {

    clear(parameter.errors);

    if (stringHelper.isEmpty(parameter.name)) {
        parameter.errors.push('Parameter name is required');
    }

    if (parameter.name.length > maxNameCharacters) {
        parameter.errors.push(`Parameter name max character count is ${maxNameCharacters}`);
    }
};

const validateFunction = (func: UserDefinedFunction, functions: UserDefinedFunction[], globalFunctions: UserDefinedFunction[], reportConfigType: string): void => {

    clear(func.errors);

    let metadataError = validateMetadata(func.name);
    if (metadataError) {
        func.errors.push(metadataError);
    }

    declarationValidator.validate(func, functions, globalFunctions, [], [], [], [], [], null as any, func.returnType, null, true, reportConfigType);
};

const validateFunctions = (functions: UserDefinedFunction[], globalFunctions: UserDefinedFunction[], reportConfigType: string): ErrorType => {

    functions.forEach(x => validateFunction(x, functions, globalFunctions, reportConfigType));

    uniquenessValidator.validate(functions, a => a.name, 'User Defined Function', 'name');

    let invalidFunction = functions.find(x => x.errors.length > 0);

    return {
        mainConmponentNumber: invalidFunction?.number as number,
        message: invalidFunction ? 'Invalid functions(s)' : ''
    } as ErrorType;
};

const validateFunctionParameters = (funcs: UserDefinedFunction[]): ErrorType => {

    funcs.forEach((func) => {
        func.parameters.forEach(x => validateFunctionParameter(x));

    });

    let functionWithErrorParameters = funcs.find(x => x.parameters.some(f => f.errors.length > 0));

    let fieldWithErrors = functionWithErrorParameters?.parameters?.find(x => x.errors.length > 0);

    return {
        message: fieldWithErrors ? 'Invalid functions(s)' : '',
        componentNumber: fieldWithErrors?.number,
        mainConmponentNumber: functionWithErrorParameters?.number as number
    }
}

const validateMetadata = (name: string): string | null => {

    if (stringHelper.isEmpty(name)) {
        return 'Function name is required';
    }

    if (name.length > maxNameCharacters) {
        return `Function name max character count is ${maxNameCharacters}`;
    }

    return null;
};

const functionValidator = {
    validateFunctions,
    validateFunction,
    validateFunctionParameter,
    validateFunctionParameters,
    validateMetadata
};

export default functionValidator;
